
import state from './sendmailState.js'
import mutations from './sendmailMutations.js'
import actions from './sendmailAction.js'
import getters from './sendmailGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

